module.exports = __webpack_public_path__ + "static/media/zopa_green_logo.b7481c3b.png";